<template>
  <div>
    <a-modal
      title="分配"
      style="top: 20px;"
      :width="800"
      v-model="visible"
      :confirmLoading="confirmLoading"
      :cancelButtonProps="{ props: {disabled: true} }"
      :maskClosable="false"
      :footer="null"
      @cancel="handleCancel"
    >
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件">
          <a-input v-model="aName.accessoryName" disabled></a-input>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业">
          <a-input v-model="eName.enterpriseName" disabled/>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库">
          <a-select
            mode="multiple"
            @change="handleChange"
            v-decorator="['storeId',{ rules: [{ required: true, message: '请选择仓库' }] }]"
          >
            <a-select-option v-for="item in data1" :key="item.storeId">
              {{item.storeName}}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <a-row>
        <a-col :span="8" :offset="10">
          <a-button type="primary" @click="handleSubmit">保存</a-button>
          <a-button style="margin-left: 8px" @click="showModal">取消</a-button>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal
      title="编辑"
      style="top: 20px"
      :width="800"
      v-model="bisable"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      :footer="false"

    >
      <div>
        <a-tree
          checkable
          @expand="onExpand"
          :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent"
          v-model="checkedKeys"
          style="margin-left: 300px"
          @select="onSelect"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          @check="onCheck"
        />
        <a-row :class="status == 1 ? 'readyOnly':''">
          <a-col :span="12" :offset="9">
            <a-button @click="handSubmit" type="primary" style="margin-right: 8px">提交</a-button>
            <a-button @click="handSubmit2" type="primary" style="margin-right: 8px">提交并分配</a-button>
            <a-button @click="showModal2">取消</a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { relateModelEnterpriseAccessory,queryEnterpriseAccessoryModel,queryAssignEnterpriseStock,saveAccessory,selectStoreCombox,assignEnterpriseStock,queryEnterpriseAccessoryModelExclude,selectAccessoryNameCombox,getSlectCombox,queryEnterpriseStock } from '@/api/enterprise/accessory'
import pick from 'lodash.pick'

const treeData = [];

export default {
  name: 'AccessoryModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      visible: false,
      bisable: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      data1:[],
      selectedItems: [],
      // 树型控件********************************
      expandedKeys: [],  //受控展开的树节点
      autoExpandParent: false,
      checkedKeys: [],//复选
      selectedKeys: [],
      treeData,
      eName:{},
      aName:{},
      storeName:'',
      haveUser:'',
      differentiate:0, //区分配置是新增还是编辑
      status:0
    }
  },
  beforeCreate () {
  },
  created () {
  },
  methods: {
    handleChange(selectedItems) {
      this.selectedItems = selectedItems;
    },
    // add () {
    //   this.form.resetFields()
    //   this.edit({ accessoryId: 0 })
    // },
    // 分配
    edit (record) {
      // console.log(record)
      this.visible = true
      this.storeName=record.storeName
      this.selectedItems=[]
      // this.$nextTick(() => {
      // 仓库回显
      queryAssignEnterpriseStock({accessoryId:record.accessoryId,enterpriseId:record.enterpriseId}).then(res=>{
        // console.log(res.data)
        // this.storeId = res.data
        this.mdl.storeId = res.data
        this.form.setFieldsValue(pick(this.mdl, 'storeId'))
      })
      // 匹配所有的仓库
      queryEnterpriseStock({accessoryId:record.accessoryId,enterpriseId:record.enterpriseId}).then(res=>{
        console.log(res.data)
        let data=res.data
        this.aName.accessoryName=data[0].accessoryName
        this.aName.accessoryId=data[0].accessoryId
        this.eName.enterpriseName=data[0].enterpriseName
        this.eName.enterpriseId=data[0].enterpriseId
        // console.log(this.aName,this.eName)
        for (var item in data){
          // console.log(data[item])
          if (data[item].hasOwnProperty('storeName')) {
            let str={}
            str.storeName=data[item].storeName
            str.storeId=data[item].storeId
            this.data1.push(str)
            console.log(this.data1)
          }else{
            this.selectedItems=[]
          }
        }
      })
      // })
    },
    showModal () {
      this.visible = !this.visible
      this.data1.splice(0,this.data1.length);
      this.selectedItems.splice(0,this.selectedItems.length);
    },
    handleCancel(){
      this.data1.splice(0,this.data1.length);
      this.selectedItems.splice(0,this.selectedItems.length);
    },
    // 编辑-》编辑
    delay (record,status) {
      this.status = status
      this.bisable=true
      this.haveUser = record
      this.differentiate = 1
      queryEnterpriseAccessoryModel({enterpriseId:record.enterpriseId,accessoryId:record.accessoryId}).then(res=>{
        this.treeData = res.data
        // console.log(this.treeData)
      })
      queryEnterpriseAccessoryModelExclude({enterpriseId:record.enterpriseId,accessoryId:record.accessoryId}).then(res=>{
        // console.log(res.data)
        this.checkedKeys = res.data
      })
    },
    // 新建-》编辑
    handleDelay(record){
      this.bisable=true
      this.haveUser = record
      console.log(this.haveUser)
      this.differentiate = 0
      this.checkedKeys = []
      queryEnterpriseAccessoryModel({enterpriseId:record.enterpriseId,accessoryId:record.accessoryId}).then(res=>{
        this.treeData = res.data
        // console.log(this.treeData)
      })
    },
    // 编辑提交
    handSubmit () {
      let that = this
      this.confirmLoading = true
      let str = {}
      str.enterpriseId = this.haveUser.enterpriseId
      str.accessoryId = this.haveUser.accessoryId
      str.modelIds = this.checkedKeys
      str.installTree = this.treeData
      str.differentiate = this.differentiate
      if(str.modelIds.length != 0){
        relateModelEnterpriseAccessory(str).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
            that.$emit('haveOk')
            this.bisable=false
          } else {
            this.$message.success(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        }).finally(() => {
          this.confirmLoading = false
        })
      }else{
        this.$message.error('请选择型号')
      }
    },
    handSubmit2(){
      let that = this
      this.confirmLoading = true
      let str = {}
      str.enterpriseId = this.haveUser.enterpriseId
      str.accessoryId = this.haveUser.accessoryId
      str.modelIds = this.checkedKeys
      str.installTree = this.treeData
      str.differentiate = this.differentiate
      if(str.modelIds.length != 0){
        relateModelEnterpriseAccessory(str).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
            this.edit(this.haveUser)
            that.$emit('haveOk')
            this.bisable=false
          } else {
            this.$message.success(res.msg)
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        }).finally(() => {
          this.confirmLoading = false
        })
      }else{
        this.$message.error('请选择型号')
      }
    },
    // 分配提交
    handleSubmit (e) {
      // console.log(this.selectedItems)
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log(values)
          let arr2={}
          values.enterpriseId=this.eName.enterpriseId
          values.accessoryId=this.aName.accessoryId
          arr2.storeId=this.selectedItems
          console.log(values)
          this.confirmLoading = true
          assignEnterpriseStock(values).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('ok')
              this.data1.splice(0,this.data1.length);
              this.selectedItems.splice(0,this.selectedItems.length);
              this.visible = false
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    showModal2(){
      this.bisable=false
      this.checkedKeys = []
    },
    // 树形控件*********************************
    // 展开/收起节点时触发
    onExpand(expandedKeys) {
      // console.log('onExpand', expandedKeys);
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      console.log('onCheck', checkedKeys);
      this.checkedKeys = checkedKeys;
    },
    // 点击节点树触发
    onSelect(selectedKeys, info) {
      // console.log('onSelect', info);
      this.selectedKeys = selectedKeys;//选中的节点
    },
  },
  computed: {
  },
  watch: {
    checkedKeys(val) {
      // console.log('onCheck', val);
      this.checkedKeys = val;
      // console.log(this.checkedKeys)
    },
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { padding: 4px 16px !important;}
  .readyOnly{
    pointer-events: none;
  }
</style>